import { Form, message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/api/users/getallusers");
      setUsers(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreate = () => {
    setIsEditing(false);
    setIsModalOpen(true);
    form.resetFields();
  };

  const handleEdit = (record) => {
    setCurrentUser(record);
    setIsEditing(true);
    setIsModalOpen(true);
    form.setFieldsValue(record);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/users/deleteuser/${id}`);
      message.success("User deleted successfully");
      fetchUsers();
    } catch (error) {
      message.error("Failed to delete user");
      console.log(error);
    }
  };

  const handleToggleAdmin = async (id) => {
    try {
      await axios.put(`/api/users/assignadmin/${id}`);
      message.success("Admin status updated");
      fetchUsers();
    } catch (error) {
      message.error("Failed to update admin status");
      console.log(error);
    }
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      if (isEditing) {
        // Update existing user
        await axios.put(`/api/users/edituser/${currentUser._id}`, values);
        message.success("User updated successfully");
      } else {
        // Create new user
        await axios.post("/api/users/register", values);
        message.success("User created successfully");
      }
      setIsModalOpen(false);
      fetchUsers();
    } catch (error) {
      message.error("Failed to save user");
      console.log(error);
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return {
    users,
    isModalOpen,
    isEditing,
    showPassword,
    form,
    handleCreate,
    handleEdit,
    handleDelete,
    handleToggleAdmin,
    handleModalOk,
    handleModalCancel,
    togglePasswordVisibility,
  };
};
